import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/creators/{creatorSlug}/members']['GET'];

const getMembers = async ({
  creatorSlug,
  page,
  perPage,
  search,
  searchInProfileNotes,
  filter,
  status,
  sort,
  withNames,
}: ThisApi['params'] & ThisApi['query']): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.get<ThisApi['response']>(`/creators/${creatorSlug}/members`, {
    params: {
      filter,
      page,
      perPage,
      search,
      searchInProfileNotes,
      sort,
      status,
      withNames,
    },
  });
  return response.data as ThisApi['response'];
};

export default getMembers;
